import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Tooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
import i18n from "./localization";
import { appealsActions } from "../store/actions";
import downloadFile from "../../../helpers/downloadFile";

const RecallByRegistratorInfo = ({ isRu, reOrgAppealId }) => {
    const [file, setFile] = useState(null);

    const { recallByRegistratorFiles, recallBasisFile } = useSelector((state) => state.appealsReducer);

    const dispatch = useDispatch();

    const getFiles = (params) => dispatch(appealsActions.getRecallByRegistratorFiles(params));

    const downloadBasisFile = useCallback(params => dispatch(appealsActions.downloadRecallBasisFile({
		FileId: params.id
	})), [dispatch])

    useEffect(() => {
        getFiles({reOrgAppealId: reOrgAppealId});
        
        return () => {
            dispatch(appealsActions.clearRecallByRegistratorFiles());
        };
    }, []);

    useEffect(() => {
        if (recallBasisFile)
            downloadFile(recallBasisFile, file);
    }, [recallBasisFile]);

    function getFile(item) {
        setFile(item);
        downloadBasisFile({id: item.id});
    }
    
    return (
        <>
            {recallByRegistratorFiles?.length > 0 && (
                <Col>
                    <Row justify="center" className="header-result-appeal">
                        <span>{i18n.recallByRegistratorSuccess[isRu]}</span>
                        <span></span>
                    </Row>
                    <Row justify="start">
                        <span>{i18n.basis[isRu]}</span>
                    </Row>
                    <Row justify="start" className="files-body-info-appeal">
                        <div>
                            {recallByRegistratorFiles.map((file) => {
                                return (
                                    <div
                                        key={`recallByRegistratorFile_${file.id}`}
                                        className="custom-file"
                                    >
                                        <Tooltip
                                            placement="left"
                                            title={
                                                file.fileName +
                                                file.fileExtension
                                            }
                                        >
                                            <a onClick={() => getFile(file)}>
                                                {file.fileName +
                                                    file.fileExtension}
                                            </a>
                                        </Tooltip>
                                    </div>
                                );
                            })}
                        </div>
                    </Row>
                </Col>
            )}
        </>
    );
};

export default RecallByRegistratorInfo;
